import React, { useEffect, useState } from "react";
import { Modal } from "../../Components";
import {  Toast } from "../../Components";
import ListAdd from "./ListAdd";
import { utils } from "../../Helpers";
import ShowInfluencer from "./ShowInfluencer";
import ListMain from "./ListMain";
import { influencerlistService } from "../../Services";
import { ModalConfirmDeleteInfluencer } from "../../Components";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { storageHandler } from "../../Helpers/storage";
import { parseInput } from "../../Components/Constants/AppConstant";
import { useSearchParams } from "react-router-dom";

export default function InfluencerList({
  goToPricing,
  setShowCart,
  updateProfilePage,
  setUpdateProfilePage,
  setUserTypeRegOrNon,
  setCartItem,
  cartItem,
  closeCartPanel,
  setAuth,
  setModal,
  user,
  NotifModul,
  profiles,
  setModalNotification,
  locationData,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams.get("tab") || "main");
  const [modalDataList, setModalDataList] = useState(() => {
    const saved = sessionStorage.getItem("modalDataList");
    return saved ? JSON.parse(saved) : null;
  });
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const [toastList, setToastList] = useState([]);
  const [list, setList] = useState([]);
  const [selectDesc, setselectDesc] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchList, setSearchList] = useState(false);
  const [tabModal, setTabModal] = useState("main");
  const [selectedInfluencer, setSelectedInfluencer] = useState({});
  const [goBack, setGoBack] = useState(false);
  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam) {
      setTab(tabParam);
    } else {
      setTab("main");
      sessionStorage.removeItem("modalDataList");
    }
    setPage(1);
    setSearchText("");
    setselectDesc("");
  }, [locationData.key]);

  useEffect(() => {
    if (modalDataList) {
      sessionStorage.setItem("modalDataList", JSON.stringify(modalDataList));
    }
  }, [modalDataList]);

  useEffect(() => {
    async function fetchData() {
      let filterString = "";
      if (searchText !== "" && selectDesc !== "") {
        filterString += "&search=" + searchText;
      }
      try {
        const res = await influencerlistService.getAllList({
          page: page,
          pageSize,
          filter: filterString,
        });
        //console.log(res.data.data)
        if (res.success === true) {
          setList(res.data.data);
          setIsLoaded(true);
          let paginationObj = utils.createPaginationData(res.data);
          setPaginationData(paginationObj);
        }
      } catch (err) {
        if (err.apiResponseStatus !== 404) {
          let error = parseInput(err.message);
          addToast({
            error: true,
            msg: error.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsLoaded(true);
        }
      }
    }
    fetchData();
  }, [page, searchList, goBack]);
  const onPaginate = (page) => {
    setPage(page);
  };
  const changeMediumDesc = (item) => {
    setselectDesc(item.id);
    setPage(1);
    setSearchText("");
    setSearchList(!searchList);
  };
  const setSearchTextOnChange = (event) => {
    if (event.target.value === "") {
      setSearchList(!searchList);
      setselectDesc("");
    }
    setSearchText(event.target.value);
  };
  const search = () => {
    setSearchList(!searchList);
    setPage(1);
  };
  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    if (newToastList.length > 0) {
      setToastList(newToastList);
    }
  };
  const removeInfFromList = async () => {
    const listId = modalDataList.id;
    const id = selectedInfluencer.id;
    const inftype = selectedInfluencer.type;
    try {
      let option = { inf_user_id: id, inf_user_type: inftype };
      const res = await influencerlistService.removeFromList(listId, option);
      if (res.success === true) {
        addToast({
          error: false,
          msg: res.message,
          id: `${Date.now()}-${toastList.length}`,
        });
        setTabModal(null);
        setSelectedInfluencer({});
      }
    } catch (err) {
      if (!err.apiResponseStatus) {
        addToast({
          error: true,
          msg: err.replaceAll(/<\/?[^>]+(>|$)/gi, ""),
          id: `${Date.now()}-${toastList.length}`,
        });
      } else {
        addToast({
          error: true,
          msg: err.message,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    }
  };

  const deleteList = async () => {
    try {
      if (modalDataList.id) {
        const deleteID = modalDataList.id;
        //console.log(deleteID);
        const res = await influencerlistService.deleteList(deleteID);
        if (res.success === true) {
          addToast({
            error: true,
            msg: res.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        }
        setTabModal(null);
        setTab("main");
        setGoBack(!goBack);
      }
    } catch (err) {
      addToast({
        error: true,
        msg: err.message,
        id: `${Date.now()}-${toastList.length}`,
      });
    }
  };

  let data = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }
  useEffect(() => {
    data.p_f_ids.includes(16);
  }, []);
  return (
    <>
      {data.p_f_ids.includes(4) ? (
        <>
          <div className="">
            {/* {tab !== "main" && (
                <button
                  className="button tertiary big"
                  style={{ marginBottom: 0 }}
                  onClick={() => {
                    setGoBack(!goBack);
                    sessionStorage.removeItem("modalDataList");
                    setSearchParams({});
                    setTab("main");
                    onPaginate(1);
                  }}
                >
                  {arrowLeft} Back to list
                </button>
              )} */}

            {tab === "main" && isLoaded === true && (
              <ListMain
                listAll={list}
                setTab={setTab}
                setModalDataList={setModalDataList}
                paginationData={paginationData}
                onPaginate={onPaginate}
                isLoaded={isLoaded}
                setTabModal={setTabModal}
                setList={setList}
                changeMediumDesc={changeMediumDesc}
                setSearchTextOnChange={setSearchTextOnChange}
                search={search}
                searchText={searchText}
                selectDesc={selectDesc}
                setShowCart={setShowCart}
              />
            )}
            {tab === "listinfluencer" && (
              <ShowInfluencer
                setShowCart={setShowCart}
                setUpdateProfilePage={setUpdateProfilePage}
                updateProfilePage={updateProfilePage}
                setUserTypeRegOrNon={setUserTypeRegOrNon}
                setCartItem={setCartItem}
                cartItem={cartItem}
                selectedInfluencer={selectedInfluencer}
                removeInfFromList={removeInfFromList}
                setSelectedInfluencer={setSelectedInfluencer}
                setModalDataList={setModalDataList}
                setTabModal={setTabModal}
                modalDataList={modalDataList}
                setTab={setTab}
                setToastList={setToastList}
                toastList={toastList}
                addToast={addToast}
                tabModal={tabModal}
                user={user}
                setGoBack={setGoBack}
                tab={tab}
                setSearchParams={setSearchParams}
                goBack={goBack}
              />
            )}
          </div>
          {tabModal === "delete" && (
            <Modal addClass="modalAsset" close={() => setTabModal(null)}>
              <div className="modal__asset">
                <div className="modal__asset-inner">
                  <div className="modal__assetDetail-delete">
                    <h4>Are you sure you want to delete this list?</h4>
                    <div className="modal__assetDetail-delete-btns">
                      <button
                        className="button secondary"
                        onClick={() => setTabModal("edit")}
                      >
                        Cancel
                      </button>
                      <button className="button primary" onClick={deleteList}>
                        Delete List
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          )}
          {tabModal === "add" && (
            <Modal addClass="modalAsset" close={() => setTabModal(null)}>
              <div className="modal__asset">
                <div className="modal__asset-inner">
                  <ListAdd
                    goBack={goBack}
                    setGoBack={setGoBack}
                    setTab={setTab}
                    setToastList={setToastList}
                    toastList={toastList}
                    setTabModal={setTabModal}
                  />
                </div>
              </div>
            </Modal>
          )}
          {tabModal === "confirmDelete" && (
            <ModalConfirmDeleteInfluencer
              setToastList={setToastList}
              toastList={toastList}
              close={() => setTabModal(null)}
              setTabModal={setTabModal}
              removeFromList={removeInfFromList}
            />
          )}
          {toastList && <Toast list={toastList} setList={setToastList} />}
        </>
      ) : (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"List"}
            background={"background_inflist.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
}
